export const ALL = 'ALL';
export const TODAY = 'TODAY';
export const YESTERDAY = 'YESTERDAY';
export const THIS_WEEK = 'THIS_WEEK';
export const LAST_WEEK = 'LAST_WEEK';
export const THIS_MONTH = 'THIS_MONTH';
export const LAST_MONTH = 'LAST_MONTH';
export const THIS_YEAR = 'THIS_YEAR';
export const LAST_YEAR = 'LAST_YEAR';